import React from "react";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import CloudStorage from "../../../../CloudStorage/CloudStorage";
import CustomReactQuill2 from "../../../Common/CustomeLabel/ReactQuill/CustomReactQuill2";
import { descriptionvalidation } from "../../../Common/commonvalidation";

export default function ModalDescription({
  setFormData,
  description,
  setModalDescription,
  handleInputDescription,
  hitApi,
}) {
  const initialValues = {
    description: description || "",
  };

  const validationSchema = Yup.object().shape({
    description: descriptionvalidation
  });

  const handleSubmit = (values) => {
    handleInputDescription({
      target: { name: "description", value: values.description },
    });
    setModalDescription(false);
    hitApi();
    setFormData((prevFormData) => ({
      ...prevFormData,
      description: values.description,
    }));
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
      enableReinitialize
    >
      {({ setFieldValue, values }) => (
        <Form>
          <button
            onClick={() => setModalDescription(false)}
            className ="btn close-button d-block"
          >
            <img
              src={`${CloudStorage.cloudurl}/Assets/Images/common/close-icon.svg`}
              alt=""
            />
          </button>
          <ModalBody>
            <h4>Edit Description</h4>
            <div className ="form-group">
              <CustomReactQuill2
                title={"Enter Description"}
                value={values.description}
                setFieldValue={setFieldValue}
                name={"description"}
              />
              <ErrorMessage
                name="description"
                component="div"
                className ="error"
              />
            </div>
          </ModalBody>
          <div className ="modal-footer">
            <button className ="btn" type="submit">
              Save
            </button>
          </div>
        </Form>
      )}
    </Formik>
  );
}
